/**
 * An error-level log line with no Error object behind it. Created
 * synchronously at the log call (so its stack points at the code that
 * logged), then captured as a Sentry exception named after the message.
 */
export class LoggedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'LoggedError';
  }
}
